///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'div[windeGridRow]',
    standalone: false
})
export class GridRowDirective {
    @HostBinding('class') buttonClass = 'winde-grid-row';
}
